import { render, staticRenderFns } from "./TestaCommuneNuova.vue?vue&type=template&id=3cb58934&"
import script from "./TestaCommuneNuova.vue?vue&type=script&lang=js&"
export * from "./TestaCommuneNuova.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports